<template>
    <div style="text-align: center">
        <ContentRenderer v-if="!hide" :content="journeyphase.content"></ContentRenderer>
        <v-btn v-if="initiated && !hide" color="primary" @click="next()">{{$t('general.continue')}}</v-btn>
    </div>
</template>

<script>
  import ContentRenderer from "../content/ContentRenderer";
  import applicationEventHub from "../../events/applicationEventHub";
  export default {
    name: "JourneyRenderer",
    components:{
      ContentRenderer
    },
    computed:{
      journeyphase(){
        return this.$store.state.assessment.journeyplan.journeyphase;
      },
    },
    data(){
      return {
        hide : false,
        initiated : false,
      }
    },
    mounted(){
      applicationEventHub.frameworkNavigationDisplay(true);
      applicationEventHub.$on('framework.next',this.next);
      applicationEventHub.frameworkButtonState(true,false);
      setTimeout(()=>{
        this.initiated=true;
      },800);
    },
    methods:{
      next(){
        this.hide=true;
        this.$nextTick(()=>{
          this.$store.dispatch('assessment/setPhaseIntroDisplayed',this.journeyphase.journeyphaseid);
        });
      }
    },
    beforeDestroy() {
      applicationEventHub.$off('framework.next',this.next);
      applicationEventHub.frameworkButtonState(true,true);
      applicationEventHub.frameworkNavigationDisplay(false);
    }
  }
</script>

<style scoped>

</style>